export default __webpack_public_path__ + "static/media/empty.162a3666.svg";